import { getMyLobbyRoom } from "./api/AuthClient.js";
import { socialSocket } from "./api/SocialSocket.js";
import { appState, loadSession, type AppScreen } from "./state/AppState.js";
import { renderLobbyScreen } from "./ui/LobbyScreen.js";
import { renderLoginScreen } from "./ui/LoginScreen.js";
import { renderMatchScreen } from "./ui/MatchScreen.js";
import { renderRoomBrowserScreen, renderRoomLobbyScreen } from "./ui/RoomScreens.js";

const root = document.getElementById("app")!;
let currentScreen: AppScreen | null = null;
let lastToken: string | null = null;

loadSession();

// On page load, if the user was in an in-progress match, rejoin it.
async function restoreActiveMatch(): Promise<void> {
  if (!appState.get().token) return;
  try {
    const { room } = await getMyLobbyRoom();
    if (!room) return;
    if (room.status === "in_progress" && room.assignment) {
      appState.set({
        screen: "match",
        matchAssignment: {
          roomId: room.id,
          mode: room.config.mode,
          serverId: room.assignment.serverId,
          serverHost: room.assignment.serverHost,
          serverPort: room.assignment.serverPort,
          tutorialLevel: null,
        },
        currentRoomId: null,
      });
    } else if (room.status === "waiting" || room.status === "starting") {
      appState.set({ screen: "room", currentRoomId: room.id });
    }
  } catch {
    // No active room or auth failure — stay on lobby
  }
}

void restoreActiveMatch();

appState.subscribe((state) => {
  if (state.token && state.token !== lastToken) {
    lastToken = state.token;
    socialSocket.connect();
  } else if (!state.token && lastToken) {
    lastToken = null;
    socialSocket.disconnect();
  }

  if (state.screen === "match") {
    socialSocket.setStatus("in_match");
  } else if (state.token) {
    socialSocket.setStatus("online");
  }

  if (state.screen === currentScreen) return;
  currentScreen = state.screen;
  root.innerHTML = "";
  if (state.screen === "login") {
    renderLoginScreen(root);
  } else if (state.screen === "lobby" || state.screen === "queue") {
    renderLobbyScreen(root);
  } else if (state.screen === "room_browser") {
    renderRoomBrowserScreen(root);
  } else if (state.screen === "room") {
    renderRoomLobbyScreen(root);
  } else if (state.screen === "match") {
    void renderMatchScreen(root);
  }
});
